import {
  ApplianceSettings,
  ApplianceType,
  MatroxE4ApplianceSettings,
  MatroxDecoderApplianceSettings,
} from 'common/api/v1/types'
import MatroxE4ApplianceSettingsComp from './MatroxE4ApplianceSettingsComp'
import MatroxDecoderApplianceSettingsComp from './MatroxDecoderApplianceSettingsComp'
import { Checkbox } from '../../../../common/Form'

interface Props {
  devMode: boolean
  type: ApplianceType
  settings: ApplianceSettings | undefined
}

const ApplianceSpecificSettings = ({ type, settings }: Props) => {
  return (
    <>
      <Checkbox
        label={'Use dynamic tunnel client source address (0.0.0.0)'}
        name={`settings.useDynamicTunnelClientSourceAddress`}
        tooltip="Enabling this setting will ensure that new tunnels are created with a source address of 0.0.0.0. Enable this on appliances where you want to use multiple NICs for the video traffic."
      />

      {[ApplianceType.matroxMonarchEdgeD4, ApplianceType.matroxMonarchEdgeS1].includes(type) && (
        <MatroxDecoderApplianceSettingsComp settings={settings as MatroxDecoderApplianceSettings} />
      )}
      {[ApplianceType.matroxMonarchEdgeE4_8Bit, ApplianceType.matroxMonarchEdgeE4_10Bit].includes(type) && (
        <MatroxE4ApplianceSettingsComp settings={settings as MatroxE4ApplianceSettings} />
      )}
    </>
  )
}

export default ApplianceSpecificSettings
